module.exports = __webpack_public_path__ + "static/media/furniture_small_img.579344be.jpg";